import { StrapiActions, StrapiActionTypes, StrapiState } from "../../types/strapiMyTasks";

const initialState: StrapiState = {};

export const filtersDataMyTasks = (state = initialState, action: StrapiActions): StrapiState => {
  switch (action.type) {
    case StrapiActionTypes.FETCH_REQUEST_MYTASKS: {
      const { modelName } = action.payload;
      return {
        ...state,
        [modelName]: {
          data: state[modelName]?.data || [],
          loading: true,
          error: null,
        },
      };
    }

    case StrapiActionTypes.FETCH_SUCCESS_MYTASKS: {
      const { modelName, data, pagination } = action.payload;
      return {
        ...state,
        [modelName]: {
          data,
          loading: false,
          error: null,
          pagination,
        },
      };
    }

    case StrapiActionTypes.FETCH_FAILURE_MYTASKS: {
      const { modelName, error } = action.payload;
      return {
        ...state,
        [modelName]: {
          data: state[modelName]?.data || [],
          loading: false,
          error,
        },
      };
    }

    default:
      return state;
  }
};
